export const UtilMessages = {
    genericError: "Ocurrió un error inesperado. Por favor, intenta de nuevo en unos minutos.",
    dataIncomplete: "Faltan datos obligatorios. Completa la información para continuar.",
    dataIncompleteEmail: "El correo ingresado no es válido. Verifícalo e intenta nuevamente.",
    dataIncompleteCellphone: "El número de celular debe tener 10 dígitos y comenzar por 3.",
    aceptTerms: "Debes aceptar los términos y condiciones para poder continuar.",
    dataSuccessful: "¡Gracias! Hemos registrado tu información correctamente.",
    errorParameters: "La página no cargó los parámetros necesarios. Intenta refrescar.",
    errorLoadDateSetting: "No fue posible consultar los rangos de agendamiento en este momento."
  };
  

  export enum UtilTitle {
    Error = 'Algo salió mal',
    Success = '¡Todo listo!',
    Warning = 'Atención',
    Feedback = 'Para tener en cuenta'
  }
  

export const UtilDateFormats = {
    parse: {
        dateInput: 'LL',
    },
    display: {
        dateInput: 'dd-mm-YYYY',
        monthYearLabel: 'YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'YYYY',
    }
};